import { Component, OnInit, Input } from '@angular/core';

@Component({
  standalone: false,
  selector: 'mc-device-order-header',
  templateUrl: './device-order-header.component.html',
  styleUrls: ['./device-order-header.component.scss']
})
 export class DeviceOrderHeaderComponent implements OnInit {
   @Input() title!: string;

  ngOnInit(): void {}
  
}